import { jsxs, Fragment, jsx } from "react/jsx-runtime";
const DefaultField = ({ field, fieldState, error }) => {
  const { type, label, name, options = {}, choices = [], validation = [] } = field;
  if (!type || !name) return null;
  const validationRules = validation.reduce((acc, v) => (acc[v.type] = v.value, acc), {}), { value, onChange, onBlur, ref } = fieldState, handleChange = (e) => {
    onChange(e.target.value);
  }, handleCheckboxChange = (e, choiceValue) => {
    if (Array.isArray(value)) {
      const newValue = e.target.checked ? [...value, choiceValue] : value.filter((v) => v !== choiceValue);
      onChange(newValue);
    } else
      onChange(e.target.checked ? choiceValue : "");
  }, renderInput = () => {
    switch (type) {
      case "submit":
        return /* @__PURE__ */ jsx("button", { type: "submit", children: label || "Submit" });
      case "textarea":
        return /* @__PURE__ */ jsx(
          "textarea",
          {
            ref,
            name,
            onChange: handleChange,
            onBlur,
            placeholder: options.placeholder,
            ...validationRules,
            value: value ?? ""
          }
        );
      case "select":
        return /* @__PURE__ */ jsx(
          "select",
          {
            ref,
            name,
            value: value ?? "",
            onChange: handleChange,
            ...validationRules,
            onBlur,
            children: choices?.map((choice, i) => /* @__PURE__ */ jsx("option", { value: choice.value, children: choice.label }, i))
          }
        );
      case "radio":
        return choices?.map((choice, i) => /* @__PURE__ */ jsxs("label", { children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "radio",
              name,
              ref,
              value: choice.value,
              checked: value === choice.value,
              onChange: handleChange,
              onBlur,
              ...validationRules
            }
          ),
          choice.label
        ] }, i));
      case "checkbox":
        return choices?.map((choice, i) => /* @__PURE__ */ jsxs("label", { children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "checkbox",
              name,
              ref,
              value: choice.value,
              checked: Array.isArray(value) ? value.includes(choice.value) : value === choice.value,
              onChange: (e) => handleCheckboxChange(e, choice.value),
              onBlur,
              ...validationRules
            }
          ),
          choice.label
        ] }, i));
      default:
        return /* @__PURE__ */ jsx(
          "input",
          {
            type,
            ref,
            name,
            value: value ?? options.defaultValue ?? "",
            onChange: handleChange,
            ...validationRules,
            onBlur,
            placeholder: options.placeholder
          }
        );
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    label && !["hidden", "submit"].includes(type) && /* @__PURE__ */ jsx("label", { htmlFor: name, children: label }),
    renderInput(),
    error && /* @__PURE__ */ jsx("span", { className: "error", children: error })
  ] });
}, FormRenderer = (props) => {
  const {
    formData,
    getFieldState = (name) => ({
      value: void 0,
      onChange: () => {
      },
      name
      // Pass name to field for native form handling
    }),
    getFieldError,
    fieldComponents = {},
    children
  } = props, renderField = (field) => {
    const CustomComponent = fieldComponents[field.type], fieldState = getFieldState(field.name), error = getFieldError?.(field.name);
    return CustomComponent ? /* @__PURE__ */ jsx(CustomComponent, { field, fieldState, error }) : /* @__PURE__ */ jsx(DefaultField, { field, fieldState, error });
  }, elProps = Object.assign({}, props);
  return delete elProps.formData, delete elProps.getFieldState, delete elProps.getFieldError, delete elProps.fieldComponents, /* @__PURE__ */ jsxs("form", { ...elProps, id: elProps.id ?? formData?.id?.current, children: [
    formData?.fields?.map((field) => /* @__PURE__ */ jsx("div", { className: "form-field", children: renderField(field) }, field._key)),
    children,
    renderField({
      type: "submit",
      name: "submit",
      label: formData?.submitButton?.text || "Submit"
    })
  ] });
};
export {
  FormRenderer
};
//# sourceMappingURL=index.mjs.map
